module.exports = __webpack_public_path__ + "img/40_38_072_090.582167b4.jpg";